/* eslint-disable import/no-import-module-exports */
/** @jsxRuntime classic */
import 'react-app-polyfill/stable';
import './polyfill/localStorage';

import React from 'react';
import { Helmet } from 'react-helmet';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

// eslint-disable-next-line import/extensions
import '@formatjs/intl-getcanonicallocales/polyfill.js';
// eslint-disable-next-line import/extensions
import '@formatjs/intl-locale/polyfill.js';
// eslint-disable-next-line import/extensions
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-pluralrules/locale-data/da';
import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/el';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/et';
import '@formatjs/intl-pluralrules/locale-data/fi';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/ja';
import '@formatjs/intl-pluralrules/locale-data/lt';
import '@formatjs/intl-pluralrules/locale-data/lv';
import '@formatjs/intl-pluralrules/locale-data/hr';
import '@formatjs/intl-pluralrules/locale-data/nb';
import '@formatjs/intl-pluralrules/locale-data/nl';
import '@formatjs/intl-pluralrules/locale-data/no';
import '@formatjs/intl-pluralrules/locale-data/ro';
import '@formatjs/intl-pluralrules/locale-data/ru';
import '@formatjs/intl-pluralrules/locale-data/pt';
import '@formatjs/intl-pluralrules/locale-data/sv';
import '@formatjs/intl-pluralrules/locale-data/uk';

import { IS_PRODUCTION, FONT_ICON_URL } from 'constants/Global';
import buildSentryOptions from 'config/sentryOptions';

import 'utils/bfcacheReload';

import './scss/main.scss';
import 'rc-tooltip/assets/bootstrap.css';
import App from './App';
import { store } from './config/store/configureStore';

import packageJson from '../package.json';

const { name: appName, version: appVersion } = packageJson;

if (IS_PRODUCTION) {
  Sentry.init(buildSentryOptions({
    release: `${appName}@${appVersion}`,
    environment: process.env.REACT_APP_ENV,
  }));
}

const root = createRoot(document.getElementById('root'));

// eslint-disable-next-line camelcase, no-undef
const HASH = __webpack_hash__;

const renderApp = () => root.render(
  <Provider store={store}>
    <Helmet>
      <link rel="stylesheet" href={`${FONT_ICON_URL}?${HASH}`} />
    </Helmet>
    <App />
  </Provider>
);

if (!IS_PRODUCTION && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();
